/**
 * Live Studio (/live-stream) tab deep-linking. The keepsake-expiry reminder links couples to
 * https://lamirage.co/live-stream?tab=keepsake — the only page with a renewal action — so the
 * portal must open on the tab named in the URL instead of always on "overview".
 */
export const PORTAL_TABS = ["overview", "presentation", "webaddress", "social", "wishes", "download", "keepsake"] as const;
export type PortalTab = (typeof PORTAL_TABS)[number];

export function initialPortalTab(search: string): PortalTab {
  const t = new URLSearchParams(search || "").get("tab");
  return (PORTAL_TABS as readonly string[]).includes(t ?? "") ? (t as PortalTab) : "overview";
}
